import { User } from 'oidc-client-ts';

const AUTHORITY_URL = import.meta.env.VITE_AUTH_SERVER || `${window.location.origin}/auth`;
const AUTH_REALM = import.meta.env.VITE_AUTH_REALM;
const AUTH_CLIENT_ID = import.meta.env.VITE_AUTH_CLIENT_ID;
const AUTH_SESSION_KEY = `oidc.user:${AUTHORITY_URL}/realms/${AUTH_REALM}:${AUTH_CLIENT_ID}`;

/**
 * This function retrieves the authentication session from session storage.
 * It uses the OIDC client library to parse the stored user information.
 * If no session is found, it returns null.
 *
 * @returns {User | null} The authenticated user or null if not authenticated.
 */
const getAuthSession = () => {
	const oidcStorage = sessionStorage.getItem(AUTH_SESSION_KEY);

	if (!oidcStorage) {
		return null;
	}

	return User.fromStorageString(oidcStorage);
};

export default getAuthSession;
